import { useEffect, useState } from "react";

const useScrollTop = (callback, offset = 0) => {
  const [isAtTop, setIsAtTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY <= offset) {
        if (!isAtTop) {
          setIsAtTop(true);
          callback?.();
        }
      } else {
        if (isAtTop) {
          setIsAtTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [callback, offset, isAtTop]);

  return isAtTop;
};

export default useScrollTop;
